import { useEffect, useState } from 'react';
import { DndProvider } from 'react-dnd';
// import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import GamePrintingControlConfirm from './GamePrintingControlConfirm';
import GamePrintingMovableTypePreview from './GamePrintingMovableTypePreview';
import GamePrintingMovableTypes from './GamePrintingMovableTypes';
import GamePrintingPrintResult from './GamePrintingPrintResult';
import GamePrintingPrintSample from './GamePrintingPrintSample';
import GamePrintingSquares from './GamePrintingSquares';
import MovableTypePrintingProvider from './MovableTypePrintingProvider';
import { useGameContext } from "../../libs/GameProvider";

interface GamePrintingControlProps {
  onConfirm: (correct: boolean) => void,
  started: boolean,
  // progressIndex: number,
}

export const THE_TEXTS = [
  { text: '一二三四' },
];

export const THE_TEXTS_EASY = [
  { text: '一二三四' },
  { text: '沙公  ' },
  { text: 'STEM' },
  { text: 'ABCD' },
  { text: 'SPS ' },
  { text: '香港  ' },
];
export const THE_TEXTS_HARD = [
  { text: '沙田公立' },
  { text: '樂育菁莪' },
  { text: '有教無類' },
  { text: '身體健康' },
  { text: '學業進步' },
];

export default function GamePrintingControl(props: GamePrintingControlProps) {
  const { gameDifficulty } = useGameContext();
  const [theTexts, setTheTexts] = useState((1 === gameDifficulty.difficulty) ? THE_TEXTS_EASY : THE_TEXTS_HARD);
  const [theText, setTheText] = useState(theTexts[Math.floor(Math.random() * theTexts.length)].text);
  const [showPrintResult, setShowPrintResult] = useState(false);
  const [ansCorrect, setAnsCorrect] = useState(false);

  // const { setSegment } = useContext(BackgroundContext);
  // const [movableTypePos, setMovableTypePos] = useState(['left', 'right'].map((dir) => [1, 2, 3, 4, 5, 6, 7].sort(() => .5 - Math.random()).slice(0, Math.ceil(theText.length / 2)).map((i) => `${dir}-${i}`)).flat().sort(() => .5 - Math.random()));

  useEffect(() => {
    let temp = (1 === gameDifficulty.difficulty) ? THE_TEXTS_EASY : THE_TEXTS_HARD;
    setTheTexts(temp);
    console.log(temp, temp[Math.floor(Math.random() * theTexts.length)].text);
    setTheText(temp[Math.floor(Math.random() * theTexts.length)].text);
    setShowPrintResult(false);
    // setSegment([0, 120]);
    // setMovableTypePos(['left', 'right'].map((dir) => [1, 2, 3, 4, 5, 6, 7].sort(() => .5 - Math.random()).slice(0, Math.ceil(theText.length / 2)).map((i) => `${dir}-${i}`)).flat().sort(() => .5 - Math.random()));
  }, [theTexts, gameDifficulty]);

  const onPrintResultEnd = () => {
      props.onConfirm(ansCorrect);
  }

  const onConfirm = (correct: boolean) => {
    setAnsCorrect(correct);
    setShowPrintResult(true);
  }
  console.log('setShowPrintResult', setShowPrintResult);

  return (
    <>
      <DndProvider backend={TouchBackend} options={{ enableMouseEvents: true }}>
        <MovableTypePrintingProvider theText={theText}>
          <div className="">
            <GamePrintingSquares />
            <GamePrintingMovableTypes />
          </div>
          {props.started ? <GamePrintingPrintSample printResult={true} /> : null}
          {showPrintResult ? <GamePrintingPrintResult onEnd={onPrintResultEnd} /> : <GamePrintingControlConfirm onConfirm={onConfirm} />}
        </MovableTypePrintingProvider>
        <GamePrintingMovableTypePreview />
      </DndProvider>
    </>
  )
};
